import { HttpInterceptorFn } from '@angular/common/http';
import { LoginResponse } from './interfaces/user.interface';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authData = sessionStorage.getItem("auth");

  let token: string | null = null;
  if (authData) {
    const parsed: LoginResponse = JSON.parse(authData);
    token = parsed.access_token;
  }

  if (token) {
    const cloned = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }
    });
    return next(cloned);
  }

  return next(req);
};
